import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMenu } from '#pplx/frontend/aether/components/useMenu/index.js';
import { TabCheckboxMenuItem } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/TabMenuItem.js';
import { useDebouncedValue } from '#pplx/frontend/common/hooks/useDebouncedValue.js';
import Input from '#pplx/frontend/components/form/Input.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { memo, useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
function toAttachedTab(tab) {
    return {
        id: tab.uuid,
        url: tab.url ?? '',
        title: tab.label ?? '',
        faviconUrl: tab.icon?.type === 'image' ? tab.icon.url : undefined,
    };
}
export const TabsMenuContent = memo(function TabsMenuContent({ allTabs, attachedTabs, onAddTab, onRemoveTab, }) {
    const { $t } = useIntl();
    const { isMobileUserAgent } = useIsMobile();
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebouncedValue(searchQuery, 300);
    const menu = useMenu();
    const filteredTabs = useMemo(() => {
        const query = debouncedSearchQuery.trim().toLowerCase();
        if (query === '') {
            return allTabs;
        }
        return allTabs.filter((tab) => (tab.label ?? '').toLowerCase().includes(query) ||
            (tab.url ?? '').toLowerCase().includes(query));
    }, [allTabs, debouncedSearchQuery]);
    const attachedTabIds = useMemo(() => new Set(attachedTabs.map((t) => t.id)), [attachedTabs]);
    const handleTabToggle = useCallback((tab, checked) => {
        if (checked) {
            onAddTab(toAttachedTab(tab));
        }
        else {
            onRemoveTab(tab.uuid);
        }
    }, [onAddTab, onRemoveTab]);
    const onKeyDown = useCallback((event) => {
        if (event.key === 'ArrowDown') {
            // Prevent ArrowDown from scrolling the page — focus the first menu item instead
            event.preventDefault();
            menu?.focusFirstMenuItem();
            return;
        }
        // Stop propagation to prevent parent keyboard handlers from firing
        event.stopPropagation();
        if (event.key === 'Enter') {
            // Prevent default Enter key behavior (e.g., form submission or newline)
            event.preventDefault();
            const firstTab = filteredTabs[0];
            if (firstTab) {
                const attached = attachedTabIds.has(firstTab.uuid);
                handleTabToggle(firstTab, !attached);
            }
        }
    }, [menu, filteredTabs, attachedTabIds, handleTabToggle]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "p-2", onKeyDown: onKeyDown, children: _jsx(Input, { type: "text", placeholder: $t({
                        defaultMessage: 'Search tabs',
                        description: 'Placeholder text for the search input in the tabs menu',
                        id: 'ba2a26a132',
                    }), value: searchQuery, onChange: setSearchQuery, isMobileUserAgent: isMobileUserAgent }) }), filteredTabs.map((tab) => (_jsx(TabCheckboxMenuItem, { id: tab.uuid, title: tab.label ?? '', url: tab.url ?? '', faviconUrl: tab.icon?.type === 'image' ? tab.icon.url : undefined, checked: attachedTabIds.has(tab.uuid), onCheckedChange: (checked) => handleTabToggle(tab, checked) }, tab.uuid)))] }));
});
//# sourceMappingURL=TabsMenuContent.js.map